// native
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

// service
import { LocalStorageService } from './local-storage.service';

// constants
import { AUTH_TOKEN_KEY, EXPANDED_LISTS_KEY, EXPANDED_SHARED_COLLECTIONS_KEY, EXPANDED_PRIVATE_COLLECTION_KEY, AUTOUPDATEBIB_KEY } from '../../constants/constants';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  isLoggedIn$: BehaviorSubject<boolean> = new BehaviorSubject(!!this.token);

  constructor(
    private localStorageService: LocalStorageService
  ) { }

  get token() {
    return this.localStorageService.getByKey(AUTH_TOKEN_KEY);
  }

  isLoggedIn() {
    return !!this.token;
  }

  login(token: string) {
    this.localStorageService.save(AUTH_TOKEN_KEY, token);
    window.location.reload();
  }

  signout() {
    this.localStorageService.delete(AUTH_TOKEN_KEY);
    this.localStorageService.delete(EXPANDED_LISTS_KEY);
    this.localStorageService.delete(EXPANDED_SHARED_COLLECTIONS_KEY);
    this.localStorageService.delete(EXPANDED_PRIVATE_COLLECTION_KEY);
    this.localStorageService.delete(AUTOUPDATEBIB_KEY);

    this.isLoggedIn$.next(false);
  }
}